// extracted by mini-css-extract-plugin
module.exports = {"documents":"Documents_documents__2TYzL","column":"Documents_column__1cc9A","file":"Documents_file__2r-qQ"};